(function () {
  'use strict';

  var config = window.__VENDI_CONFIG || {};
  var API_BASE = (config.apiBase || 'https://api.vendi.se').replace(/\/+$/, '');
  var STORAGE_KEY = 'vendiRef';
  var SESSION_REF_KEY = 'vendi_session_ref';
  var SESSION_TRACK_KEY = 'vendi_session_tracked';
  var ATTR_CODE = 'v_seller';
  var ATTR_NAME = 'Säljare';
  var ATTR_GROUP = 'Grupp';

  function getRefFromUrl() {
    try {
      return new URL(location.href).searchParams.get('ref') || '';
    } catch (e) {
      return '';
    }
  }

  function loadSaved() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}');
    } catch (e) {
      return {};
    }
  }

  function saveRef(code) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify({ ref: code, t: Date.now() }));
    try {
      sessionStorage.setItem(SESSION_REF_KEY, code);
    } catch (e) {}
  }

  function dispatch(info) {
    window.__VENDI_REF_INFO = info || null;
    document.dispatchEvent(new CustomEvent('vendi:ref-updated', { detail: info || null }));
  }

  function cartRequest(url, options) {
    return fetch(url, Object.assign({ credentials: 'same-origin' }, options || {}));
  }

  function getCartAttributes() {
    return cartRequest('/cart.js')
      .then(function (r) {
        return r.ok ? r.json() : null;
      })
      .then(function (cart) {
        return (cart && cart.attributes) || {};
      })
      .catch(function () {
        return {};
      });
  }

  function updateCartAttributes(attrs) {
    return cartRequest('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: attrs }),
    }).catch(function () {});
  }

  function resolveSeller(code) {
    return fetch(API_BASE + '/api/public/ref/resolve?ref=' + encodeURIComponent(code), {
      method: 'GET',
      credentials: 'omit',
      headers: { Accept: 'application/json' },
    })
      .then(function (r) {
        if (!r.ok) throw new Error('resolve_' + r.status);
        return r.json();
      })
      .then(function (data) {
        if (data && data.ok && data.seller_name) return data;
        throw new Error('no_name');
      });
  }

  function trackClick(code) {
    try {
      if (sessionStorage.getItem(SESSION_TRACK_KEY) === code) return;
    } catch (e) {
      return;
    }

    fetch(API_BASE + '/api/public/ref/track-click', {
      method: 'POST',
      credentials: 'omit',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ ref: code }),
    })
      .then(function () {
        try {
          sessionStorage.setItem(SESSION_TRACK_KEY, code);
        } catch (e) {}
      })
      .catch(function () {});
  }

  function applyAttributes(code, resolved) {
    return getCartAttributes().then(function (existing) {
      var attrs = {};

      if (!existing[ATTR_CODE]) {
        attrs[ATTR_CODE] = code;
      } else if (String(existing[ATTR_CODE]).toUpperCase() !== code.toUpperCase()) {
        attrs[ATTR_CODE] = code;
      }

      if (resolved) {
        attrs[ATTR_NAME] = resolved.seller_name;
        if (resolved.group_name) attrs[ATTR_GROUP] = resolved.group_name;
        attrs[ATTR_CODE] = code;
      }

      if (!Object.keys(attrs).length) return;
      return updateCartAttributes(attrs);
    });
  }

  function init() {
    var urlRef = getRefFromUrl();
    var saved = loadSaved();
    var sessionRef = '';

    try {
      sessionRef = sessionStorage.getItem(SESSION_REF_KEY) || '';
    } catch (e) {}

    var code = urlRef || saved.ref || sessionRef || '';
    if (!code) {
      dispatch(null);
      return;
    }

    saveRef(code);

    if (urlRef) {
      trackClick(code);
    }

    applyAttributes(code);

    resolveSeller(code)
      .then(function (info) {
        return applyAttributes(code, info).then(function () {
          dispatch({
            ref: code,
            seller_name: info.seller_name,
            user_id: info.user_id,
            group_id: info.group_id,
            group_name: info.group_name,
          });
        });
      })
      .catch(function () {
        dispatch(null);
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
